var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:{ current: _vm.stepNumber === _vm.currentRegistrationStep }},[_c('span',{staticClass:"circle-icon"},[_vm._v(_vm._s(_vm.stepNumber))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }